export default {
  title_one: 'Kertakäyttö, {{discount}}',
  title_other: '{{count}} käyttökertaa, {{discount}}',
  labels: {
    fixed_discount: '{{discount}} kokonaisalennus',
    percentage_discount: 'Prosentuaalinen alennus',
  },
  buttons: {
    add_component: 'Lisää käyttökerta',
  },
};
